import { render, staticRenderFns } from "./badgeCategory.vue?vue&type=template&id=47e4e37a&scoped=true&"
import script from "./badgeCategory.vue?vue&type=script&lang=js&"
export * from "./badgeCategory.vue?vue&type=script&lang=js&"
import style0 from "./badgeCategory.vue?vue&type=style&index=0&id=47e4e37a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e4e37a",
  null
  
)

export default component.exports